export const ROUTE_DEFAULT = '/';
export const ROUTE_LOGIN = '/login';

export const ROUTE_DASHBOARD = '/dashboard';
export const ROUTE_DASHBOARD_INSPECTIONS = '/dashboard/inspections/:userIdentity/:requestId';
export const ROUTE_DASHBOARD_LOGOUT='';


// WEBPACK FOOTER //
// ./src/constants/routes/routes-ui.js